import { Component } from '@niknevis/vue-modules'
import Vue, { CreateElement } from 'vue'
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QTd from 'quasar/src/components/table/QTd.js';

export interface TesTableBody {
  [key: string]: any
}

@Component
export class TesTableBody extends Vue {
  __getTBodyTR(h: CreateElement, row, bodySlot, pageIndex) {
    const
      key = this.getRowKey(row),
      selected = this.isRowSelected(key)

    // if bodySlot is present, use it
    // else if rowComponent prop is present render it
    if (bodySlot !== void 0 || this.rowComponent !== void 0) {
      const bodyData = this.__getBodyScope({
        key,
        row,
        pageIndex,
        grid: this.grid,
        __trClass: selected ? 'selected' : ''
      })

      return bodySlot
        ? bodySlot(bodyData)
        : this.rowComponent
          ? h(this.rowComponent, {
            key,
            props: bodyData
          })
          : null
    }

    const
      bodyCell = this.$scopedSlots['body-cell'],
      child = this.computedCols.map(col => {
        const
          bodyCellCol = this.$scopedSlots[`body-cell-${col.name}`],
          slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell

        if (slot !== void 0) {
          return slot(this.__getBodyCellScope({ key, row, pageIndex, col }))
        } else if (col.component) {
          const props = this.__getBodyCellScope({ key, row, pageIndex, col })

          return h(QTd, {
            props: props
          }, [
            h(col.component, {
              props: {
                props,
                ...props
              }
            })
          ])
        } else {
          return h('td', {
            class: col.__tdClass,
            style: col.style
          }, this.getCellValue(col, row))
        }
      })

    if (this.hasSelectionMode === true) {
      const slot = this.$scopedSlots['body-selection']
      const content = slot !== void 0
        ? slot(this.__getBodySelectionScope({ key, row, pageIndex }))
        : [
          h(QCheckbox, {
            props: {
              value: selected,
              color: this.color,
              dark: this.isDark,
              dense: this.dense
            },
            on: {
              input: (adding, evt) => {
                this.__updateSelection([key], [row], adding, evt)
              }
            }
          })
        ]

      child.unshift(
        h('td', { staticClass: 'q-table--col-auto-width' }, content)
      )
    }

    const data = { key, class: { selected }, on: {} as any }

    if (this.qListeners['row-click'] !== void 0) {
      data.class['cursor-pointer'] = true
      data.on.click = evt => {
        this.$emit('row-click', evt, row, pageIndex)
      }
    }

    if (this.qListeners['row-dblclick'] !== void 0) {
      data.class['cursor-pointer'] = true
      data.on.dblclick = evt => {
        this.$emit('row-dblclick', evt, row, pageIndex)
      }
    }

    if (this.qListeners['row-contextmenu'] !== void 0) {
      data.class['cursor-pointer'] = true
      data.on.contextmenu = evt => {
        this.$emit('row-contextmenu', evt, row, pageIndex)
      }
    }

    return h('tr', data, child)
  }
}
